/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrefillFreelancerVatNumberResponse
 */
export interface PrefillFreelancerVatNumberResponse {
    /**
     * Number of freelancer company ids read from the CSV for which a command was fired
     * @type {number}
     * @memberof PrefillFreelancerVatNumberResponse
     */
    commandsFired: number;
}

/**
 * Check if a given object implements the PrefillFreelancerVatNumberResponse interface.
 */
export function instanceOfPrefillFreelancerVatNumberResponse(value: object): value is PrefillFreelancerVatNumberResponse {
    if (!('commandsFired' in value) || value['commandsFired'] === undefined) return false;
    return true;
}

export function PrefillFreelancerVatNumberResponseFromJSON(json: any): PrefillFreelancerVatNumberResponse {
    return PrefillFreelancerVatNumberResponseFromJSONTyped(json, false);
}

export function PrefillFreelancerVatNumberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrefillFreelancerVatNumberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'commandsFired': json['commandsFired'],
    };
}

export function PrefillFreelancerVatNumberResponseToJSON(value?: PrefillFreelancerVatNumberResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'commandsFired': value['commandsFired'],
    };
}

